import { Suspense } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LoadingScreen } from "@/components/ui/loading-screen";
import { EcosuiteErrorBoundary } from "@/components/error-boundary";
import { ReactNode } from "react";

interface UserStatsCardsProps {
  statsData: Array<{
    name: string;
    value: number;
    icon: ReactNode;
  }>;
}

function UserStatsCardsContent({ statsData }: UserStatsCardsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {statsData.map((stat) => (
        <Card
          key={stat.name}
          className="border-muted/50 overflow-hidden shadow-sm"
        >
          <CardHeader className="pb-0 pt-3">
            <div className="flex items-center justify-between">
              <CardTitle className="text-muted-foreground text-xs font-medium">
                {stat.name}
              </CardTitle>
              {stat.icon}
            </div>
          </CardHeader>
          <CardContent className="pt-2">
            <div className="text-xl font-semibold">{stat.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export function UserStatsCards(props: UserStatsCardsProps) {
  return (
    <EcosuiteErrorBoundary>
      <Suspense
        fallback={<LoadingScreen text="Loading stats..." className="h-24" />}
      >
        <UserStatsCardsContent {...props} />
      </Suspense>
    </EcosuiteErrorBoundary>
  );
}
